import { render, staticRenderFns } from "./MagazaSatis.vue?vue&type=template&id=64915883&scoped=true&"
import script from "./MagazaSatis.vue?vue&type=script&lang=js&"
export * from "./MagazaSatis.vue?vue&type=script&lang=js&"
import style0 from "./MagazaSatis.vue?vue&type=style&index=0&id=64915883&lang=scss&scoped=true&"
import style1 from "./MagazaSatis.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64915883",
  null
  
)

export default component.exports